class Deferred<T> {
  instance: T | undefined

  queuedListeners: ((instance: T) => void)[] = []

  init = (instance: T) => {
    this.instance = instance
    this.queuedListeners.forEach((resolve) => {
      resolve(instance)
    })
  }

  get = (): Promise<T> => {
    if (this.instance) return Promise.resolve(this.instance)
    return new Promise((res) => {
      this.queuedListeners.push(res)
    })
  }
}

export { Deferred }
